import axiosClient from './axiosClient';

/**
 * First-stage review queue — bookings and technician applications.
 * Backend: /api/v1/review/**  (ADMIN and APPROVER).
 */
const reviewService = {
  // Bookings awaiting the admin/approver's first approval
  bookingQueue: (params = {}) => axiosClient.get('/review/bookings', { params }),
  approveBooking: (id) => axiosClient.post(`/review/bookings/${id}/approve`),
  rejectBooking: (id, reason) => axiosClient.post(`/review/bookings/${id}/reject`, { reason }),

  // Technician applications
  technicianQueue: (params = {}) => axiosClient.get('/review/technicians', { params }),
  approveTechnician: (id) => axiosClient.post(`/review/technicians/${id}/approve`),
  rejectTechnician: (id, reason) => axiosClient.post(`/review/technicians/${id}/reject`, { reason }),
};

export default reviewService;
